import React from 'react';
import Styled from 'styled';

import ResponsiveImageView from 'lib/images/responsive-image-view';
import ImageView from 'lib/images/image-view';
import withFileThumbnail from 'lib/images/with-file-thumbnail';

import defaultStyles from './file-thumbnail-view.scss';

class FileThumbnailView extends React.Component {
    render() {
        const { file, url, value, styles, orientation } = this.props;

        return (
            <div className={styles.fileThumbnail}>
                {file && url ? (
                    <ImageView alt={file.name} aspectFill={true} src={url} orientation={orientation} />
                ) : (
                    <ResponsiveImageView image={value} aspectFill={true} sizes={{ xs: 25 }} />
                )}
            </div>
        );
    }
}

export default withFileThumbnail()(Styled(defaultStyles)(FileThumbnailView));
